import { ElementRef } from '@angular/core';
import { Directive } from '@angular/core';

@Directive({
    selector: '[appSidebarIphoneFix]',
    standalone: false
})
export class SidebarIphoneDirective {

    constructor(el: ElementRef) {
        if (this.checkPlatform()) {
            el.nativeElement.classList.add('ios-fix-sidebar');
        }
    }

    private checkPlatform() {
        return [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod'
        ].includes(navigator.platform);
    }

}
